import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { Order } from "../interfaces/Order";

interface CancelOrderDialogProps {
  open: boolean;
  order: Order | null;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export function CancelOrderDialog({ open, order, onClose, onConfirm }: CancelOrderDialogProps) {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) return;
    onConfirm(reason.trim());
    setReason("");
    onClose();
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  if (!order) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main', fontWeight: 800 }}>
        <WarningIcon />
        Anular Orden
      </DialogTitle>
      <DialogContent sx={{ mt: 1 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Estás a punto de anular la orden <strong>"{order.name}"</strong>. Esta acción la marcará como cancelada.
        </Typography>
        <Box sx={{ bgcolor: '#fef2f2', p: 2, borderRadius: 2, border: '1px solid #fecaca', mb: 2 }}>
          <Typography variant="body2" color="error.dark" fontWeight={700}>
            Por favor, indica el motivo de la anulación:
          </Typography>
        </Box>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          placeholder="Ej: Cliente canceló el pedido, error en la toma, producto agotado..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          error={reason.trim() === ""}
          helperText={reason.trim() === "" ? "El motivo es obligatorio" : ""}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={handleClose} color="inherit" sx={{ fontWeight: 700, borderRadius: 2 }}>
          Volver
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          color="error" 
          disabled={reason.trim() === ""}
          sx={{ fontWeight: 800, borderRadius: 2, px: 3 }}
        >
          Confirmar Anulación
        </Button>
      </DialogActions>
    </Dialog>
  );
}
